import {volumeChange, VolumeChange} from "./volume-change/DepthVolumeChangeDirective";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.directives`;

    return angular.module(moduleName, [])
                  .directive(VolumeChange, volumeChange)
                  .name;
}
